<template>
  <v-app>
    <component :is="layout"></component>

    <v-snackbar
      v-model="snackShow"
      bottom
      right
      :color="snackLevel"
      class="elevation-0"
    >
      {{ snackMsg }}
      <v-btn text @click="snackShow = false">Chiudi</v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import AppLayout from "@/layouts/AppLayout"
import SimpleLayout from "@/layouts/SimpleLayout"

export default {
  components: {
    "app-layout": AppLayout,
    "simple-layout": SimpleLayout,
  },
  data() {
    return {
      snackShow: false,
      snackMsg: "",
      snackLevel: null,
    }
  },
  computed: {
    layout() {
      if (
        ["Login", "ResetPassword", "ResetPasswordConfirm"].includes(
          this.$route.name
        )
      ) {
        return "simple-layout"
      }
      return "app-layout"
    },
  },
  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === "core/setSnack") {
        this.snackMsg = state.core.snack.msg
        this.snackLevel = state.core.snack.level
        this.snackShow = true
      }
    })
  },
}
</script>
